import { render, staticRenderFns } from "./HomeInfo.vue?vue&type=template&id=5ab9d6ae&scoped=true&"
import script from "./HomeInfo.vue?vue&type=script&lang=js&"
export * from "./HomeInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab9d6ae",
  null
  
)

export default component.exports